import axios from "axios";

/* FMCSA */
const SAFER_URL = 'https://mobile.fmcsa.dot.gov/qc/services/carriers';
const WEB_KEY = '91081216105da19d98017b34991957774b3607d7';

export const getCarrierBasicsByDOTNumber = async (dotNumber) => {
  let URL = `${SAFER_URL}/${dotNumber}?webKey=${WEB_KEY}`;
  return axios.get(URL);
};

/* GCP */
const ACTIVATE_INTEGRATION_URL = 'https://smartboard-api.freightsmart.ai/api/organization/activate';
const LOGIN_DAT_URL = 'https://smartboard-api.freightsmart.ai/api/dat/login';
export const activateVendorIntegration = async (payload) => {
  // return serviceHandler(URL, 'POST', payload);
  const config = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(ACTIVATE_INTEGRATION_URL, payload, config);
};

export const loginVendorPortal = async (payload) => {
  // return serviceHandler(URL, 'POST', payload);
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'X-Auth-Token': localStorage.getItem('AUTH_TOKEN'),
    }
  };
  return axios.post(LOGIN_DAT_URL, payload, config);
};